import {createAction} from "@reduxjs/toolkit";

export const settingsToggleDebug = createAction('settings/debugToggle');
export const settingsChangeDebugUrl = createAction('settings/debugUrlChange');
export const settingsUseTuneTargets = createAction('settings/useTuneTargets');
export const settingsSetClientEvent = createAction('settings/setClientEvent');
export const settingsSetEventUID = createAction('settings/setEventUID');
export const settingsToggleClientEventDebug = createAction('settings/toggleClientEventDebug');
export const settingsSetMeasureLoading = createAction('settings/setMeasureLoading');
export const settingsSetMeasureExpertView = createAction('settings/setMeasureExpertView');